<template>
  <li
    v-for="(menuItem, index) in section.visibleItems"
    :key="`${section.id}-${index}-${menuItem.title || menuItem.path}`"
    class="sidebar-list sidebar-section-content"
    :class="[
      menuItem.showPin ? 'pined' : '',
      index === 0 ? 'sidebar-section-first-child' : '',
      index === section.visibleItems.length - 1 ? 'sidebar-section-last-child' : '',
    ]"
  >
    <label :class="'badge badge-' + menuItem.badgeType" v-if="menuItem.badgeType">{{
      getTranslation(menuItem.badgeValue)
    }}</label>

    <a
      href="javascript:void(0)"
      class="sidebar-link sidebar-title"
      :class="{ active: menuItem.active }"
      v-if="menuItem.type == 'sub'"
      :title="getTranslation(menuItem.title)"
      @click="setNavActive(menuItem)"
    >
      <svg class="stroke-icon">
        <use :xlink:href="iconSprite + `#${menuItem.icon}`"></use>
      </svg>
      <svg class="fill-icon">
        <use :xlink:href="iconSprite + `#${menuItem.iconf}`"></use>
      </svg>
      <span class="lan-3">{{ getTranslation(menuItem.title) }}</span>
      <div class="according-menu" :class="{ open: menuItem.active }" v-if="menuItem.children">
        <i class="fa fa-angle-right pull-right"></i>
      </div>
    </a>

    <router-link
      :to="menuItem.path"
      class="sidebar-link sidebar-title"
      v-if="menuItem.type == 'link'"
      :class="{ active: menuItem.active }"
      :title="getTranslation(menuItem.title)"
      @click="
        setNavActive(menuItem);
        onLinkClick();
      "
    >
      <svg class="stroke-icon">
        <use :xlink:href="iconSprite + `#${menuItem.icon}`"></use>
      </svg>
      <svg class="fill-icon">
        <use :xlink:href="iconSprite + `#${menuItem.iconf}`"></use>
      </svg>
      <span>{{ getTranslation(menuItem.title) }}</span>
      <i class="fa fa-angle-right pull-right" v-if="menuItem.children"></i>
    </router-link>

    <a
      :href="menuItem.path"
      class="sidebar-link sidebar-title"
      v-if="menuItem.type == 'extLink'"
      :title="getTranslation(menuItem.title)"
      @click="setNavActive(menuItem)"
    >
      <svg class="stroke-icon">
        <use :xlink:href="iconSprite + `#${menuItem.icon}`"></use>
      </svg>
      <svg class="fill-icon">
        <use :xlink:href="iconSprite + `#${menuItem.iconf}`"></use>
      </svg>
      <span>{{ getTranslation(menuItem.title) }}</span>
      <i class="fa fa-angle-right pull-right" v-if="menuItem.children"></i>
    </a>

    <a
      :href="menuItem.path"
      target="_blank"
      class="sidebar-link sidebar-title"
      v-if="menuItem.type == 'extTabLink'"
      :title="getTranslation(menuItem.title)"
      @click="setNavActive(menuItem)"
    >
      <svg class="stroke-icon">
        <use :xlink:href="iconSprite + `#${menuItem.icon}`"></use>
      </svg>
      <svg class="fill-icon">
        <use :xlink:href="iconSprite + `#${menuItem.iconf}`"></use>
      </svg>
      <span>{{ getTranslation(menuItem.title) }}</span>
      <i class="fa fa-angle-right pull-right" v-if="menuItem.children"></i>
    </a>

    <ul
      class="sidebar-submenu"
      v-if="menuItem.children"
      :class="{ 'menu-open': menuItem.active }"
      :style="{ display: menuItem.active ? '' : 'none' }"
    >
      <li
        v-for="(childrenItem, childIndex) in getVisibleChildren(menuItem.children)"
        :key="`${section.id}-${index}-${childIndex}-${childrenItem.title || childrenItem.path}`"
      >
        <a
          class="lan-4 text-truncate"
          :class="{ active: childrenItem.active }"
          href="javascript:void(0)"
          v-if="childrenItem.type == 'sub'"
          @click="setNavActive(childrenItem)"
          :title="getTranslation(childrenItem.title)"
        >
          {{ getTranslation(childrenItem.title) }}
          <label
            :class="'badge badge-' + childrenItem.badgeType + ' pull-right'"
            v-if="childrenItem.badgeType"
            >{{ childrenItem.badgeValue }}</label
          >
          <i
            class="fa pull-right mt-1"
            :class="[childrenItem.active ? 'fa fa-angle-down' : 'fa fa-angle-right']"
            v-if="childrenItem.children"
          ></i>
        </a>

        <router-link
          class="lan-4 text-truncate"
          :class="{ active: childrenItem.active }"
          :to="childrenItem.path"
          v-if="childrenItem.type == 'link'"
          @click="
            setNavActive(childrenItem);
            onLinkClick();
          "
          :title="getTranslation(childrenItem.title)"
        >
          {{ getTranslation(childrenItem.title) }}
          <label
            :class="'badge badge-' + childrenItem.badgeType + ' pull-right'"
            v-if="childrenItem.badgeType"
            >{{ childrenItem.badgeValue }}</label
          >
          <i class="fa fa-angle-right pull-right mt-1" v-if="childrenItem.children"></i>
        </router-link>

        <a :href="childrenItem.path" v-if="childrenItem.type == 'extLink'" class="submenu-title">
          {{ getTranslation(childrenItem.title) }}
          <label
            :class="'badge badge-' + childrenItem.badgeType + ' pull-right'"
            v-if="childrenItem.badgeType"
            >{{ childrenItem.badgeValue }}</label
          >
          <i class="fa fa-angle-right pull-right mt-1" v-if="childrenItem.children"></i>
        </a>

        <a
          class="submenu-title"
          :href="childrenItem.path"
          target="_blank"
          v-if="childrenItem.type == 'extTabLink'"
        >
          {{ getTranslation(childrenItem.title) }}
          <label
            :class="'badge badge-' + childrenItem.badgeType + ' pull-right'"
            v-if="childrenItem.badgeType"
            >{{ childrenItem.badgeValue }}</label
          >
          <i class="fa fa-angle-right pull-right mt-1" v-if="childrenItem.children"></i>
        </a>

        <ul
          class="nav-sub-childmenu submenu-content"
          v-if="childrenItem.children"
          :class="{ opensubchild: childrenItem.active }"
        >
          <li
            v-for="(childrenSubItem, subIndex) in getVisibleChildren(childrenItem.children)"
            :key="`${section.id}-${index}-${childIndex}-${subIndex}-${childrenSubItem.title || childrenSubItem.path}`"
          >
            <router-link
              :class="{ active: childrenSubItem.active }"
              :to="childrenSubItem.path"
              v-if="childrenSubItem.type == 'link'"
              @click="
                setNavActive(childrenSubItem);
                onLinkClick();
              "
            >
              {{ getTranslation(childrenSubItem.title) }}
              <label
                :class="'badge badge-' + childrenSubItem.badgeType + ' pull-right'"
                v-if="childrenSubItem.badgeType"
                >{{ childrenSubItem.badgeValue }}</label
              >
              <i class="fa fa-angle-right pull-right" v-if="childrenSubItem.children"></i>
            </router-link>

            <router-link :to="childrenSubItem.path" v-if="childrenSubItem.type == 'extLink'">
              {{ getTranslation(childrenSubItem.title) }}
              <label
                :class="'badge badge-' + childrenSubItem.badgeType + ' pull-right'"
                v-if="childrenSubItem.badgeType"
                >{{ childrenSubItem.badgeValue }}</label
              >
              <i class="fa fa-angle-right pull-right" v-if="childrenSubItem.children"></i>
            </router-link>
          </li>
        </ul>
      </li>
    </ul>
  </li>
</template>

<script setup lang="ts">
import iconSprite from '@/assets/svg/icon-sprite.svg';
import { inject } from 'vue';
import type { MenuItem } from '@/constants/menu/types';

defineOptions({ name: 'SectionMenuItems' });

defineProps<{
  section: { id: string; visibleItems: MenuItem[] };
}>();

const { getTranslation, getVisibleChildren, setNavActive, onLinkClick } = inject<{
  getTranslation: (key: string | undefined) => string;
  getVisibleChildren: (children: MenuItem[]) => MenuItem[];
  setNavActive: (item: MenuItem) => void;
  onLinkClick: () => void;
}>('navmenuContext')!;
</script>
